/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';
import type { RevisdomAPIViewModelsEntryVersionResponse } from './RevisdomAPIViewModelsEntryVersionResponse';
import {
    RevisdomAPIViewModelsEntryVersionResponseFromJSON,
    RevisdomAPIViewModelsEntryVersionResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryVersionResponseToJSON,
    RevisdomAPIViewModelsEntryVersionResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryVersionResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryFileResponse
 */
export interface RevisdomAPIViewModelsEntryFileResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    folderId?: number | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryVersionResponse>}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    versions?: Array<RevisdomAPIViewModelsEntryVersionResponse> | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    status?: RevisdomAPIViewModelsEntryFileResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    entryType?: RevisdomAPIViewModelsEntryFileResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    share?: Array<RevisdomAPIViewModelsUserResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryFileResponse
     */
    updatedAt?: Date | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryFileResponseStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryFileResponseStatusEnum = typeof RevisdomAPIViewModelsEntryFileResponseStatusEnum[keyof typeof RevisdomAPIViewModelsEntryFileResponseStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryFileResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryFileResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryFileResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryFileResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryFileResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryFileResponse(value: object): value is RevisdomAPIViewModelsEntryFileResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryFileResponseFromJSON(json: any): RevisdomAPIViewModelsEntryFileResponse {
    return RevisdomAPIViewModelsEntryFileResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'versions': json['versions'] == null ? undefined : ((json['versions'] as Array<any>).map(RevisdomAPIViewModelsEntryVersionResponseFromJSON)),
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'share': json['share'] == null ? undefined : ((json['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RevisdomAPIViewModelsEntryFileResponseToJSON(json: any): RevisdomAPIViewModelsEntryFileResponse {
    return RevisdomAPIViewModelsEntryFileResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryFileResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'folderId': value['folderId'],
        'versions': value['versions'] == null ? undefined : ((value['versions'] as Array<any>).map(RevisdomAPIViewModelsEntryVersionResponseToJSON)),
        'id': value['id'],
        'projectId': value['projectId'],
        'name': value['name'],
        'path': value['path'],
        'status': value['status'],
        'entryType': value['entryType'],
        'thumbnailUrl': value['thumbnailUrl'],
        'share': value['share'] == null ? undefined : ((value['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

